// TODO: uncomment when functionality to upload plots in UI is fixed
import { Divider } from 'component-library';
import { useTranslation } from 'react-i18next';

import { IndicatorName, PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { NO_RADIUS, useMapRadiusContext } from '@/components/MapOverview/components/MapRadiusContextProvider';
import { NCCard, NCCard2SectionLayout, NCCardComplianceFooter, NCCardHeader } from '@/components/NCCard/NCCard';
import { LandCoverChangeExplainer } from '@/components/NCExplainers/LandCoverChangeExplainer';
import { COMPLIANCE_LOGOS_LAND_COVER_CHANGE } from '@/config/constants';
import { usePlotFactsByRadius } from '@/pages/shared/hooks/usePlotFact';
import { getFactsFromFactArray } from '@/pages/shared/hooks/utils';

import { useLandscapeViewContext } from '../../LandscapeViewContextProvider';
import { PlotCardWrapper } from '../PlotCardWrapper';
import { LandCoverChangeGraphTile } from './GraphTile';
import { LandCoverChangeStatsTile } from './StatsTile';

export const LandCoverChange = () => {
  const { t } = useTranslation();

  return (
    <PlotCardWrapper name={t('shared.ncaDetail.details.landCoverChange.labels.landCoverChange')}>
      <LandCoverChangeCard />
    </PlotCardWrapper>
  );
};

const LandCoverChangeCard = () => {
  const { isLandscapeActive } = useLandscapeViewContext();
  const { t } = useTranslation();

  const { radius } = useMapRadiusContext();
  const radiusLabel = radius && radius !== NO_RADIUS ? ` ${t('shared.projects.labels.radiusHint', { radius })}` : '';

  const factName = IndicatorName.landcover_by_landscape_type_historic_pct_graph;

  const facts = usePlotFactsByRadius([factName]);

  const cardData = (getFactsFromFactArray(facts, factName) ?? []) as PlotReportFactElement<GraphFact[]>[];

  // TODO: MVP-6869 clean up this, FE should not be merging all the facts into one
  const cardFact = cardData?.reduce(
    (acc: PlotReportFactElement<GraphFact[]> | null, fact: PlotReportFactElement<GraphFact[]>) => {
      if (fact.name !== IndicatorName.landcover_by_landscape_type_historic_pct_graph) {
        return acc;
      }

      if (!acc) {
        return fact;
      }

      return {
        ...acc,
        value: [...(acc.value ?? []), ...(fact.value ?? [])],
      };
    },
    null,
  );

  if (!isLandscapeActive || !cardFact || !cardFact?.value) {
    return null;
  }

  return (
    <NCCard explainer={<LandCoverChangeExplainer />}>
      <NCCardHeader
        title={t('shared.ncaDetail.details.landCoverChange.labels.landCoverChange') + radiusLabel}
        className='lg:grid-cols-[1fr_1fr]'
      />
      <NCCard2SectionLayout>
        <LandCoverChangeGraphTile landCoverChange={cardFact} radius={radius} />
        <LandCoverChangeStatsTile landCoverChange={cardFact} />
      </NCCard2SectionLayout>
      <Divider />
      <NCCardComplianceFooter logos={COMPLIANCE_LOGOS_LAND_COVER_CHANGE} />
    </NCCard>
  );
};
